<div class="subscriber-infos">
  @if (subscriberInfo().name) {
    <h2>
      <span class="font-normal" translate>shared.Name</span><span>: {{ subscriberInfo().name }}</span>
    </h2>
  }
  @if (subscriberInfo().mobileNumber) {
    <h2>
      <span class="font-normal" translate>shared.MobileNumber</span><span>: {{ subscriberInfo().mobileNumber | phoneFormatWithCode }}</span>
    </h2>
  }
  @if (subscriberInfo().landlineNumber) {
    <h2>
      <span class="font-normal" translate>shared.LandlineNumber</span><span>: {{ subscriberInfo().landlineNumber | phoneFormatWithCode }}</span>
    </h2>
  }
  @if (subscriberInfo().email) {
    <h2>
      <span class="font-normal" translate>shared.Email</span><span>: {{ subscriberInfo().email }}</span>
    </h2>
  }
</div>
<hr class="horizontal-separator m-0" />

<h2 class="sub-header" biAutofocus translate>iFrame.Subscription.OverviewSubtitle</h2>
<div class="spinner-container">
  @if (isLoading()) {
    <div class="spinner-wrapper">
      <bi-spinner [centerInParent]="true"></bi-spinner>
    </div>
  } @else {
    <bi-skip-link skipToId="add-address" [label]="'accessibility.SkipList' | translate" />
    @if (subscriptions()?.length > 0) {
      <section class="grid w-12" @fadeInDown>
        <div class="col-12 flex">
          <p tabIndex="-1" class="w-6 text-base font-bold" translate>shared.Address</p>
          <p tabIndex="-1" class="w-2 text-base font-bold text-center" translate>shared.Type</p>
          <div tabIndex="-1" class="w-4"></div>
        </div>

        <p-divider class="w-12" [style]="{ margin: '.5rem 0' }"></p-divider>

        @for (sub of subscriptions(); track sub.id) {
          <div class="col-12 flex">
            <p tabIndex="0" class="w-6">{{ sub.locationName }}</p>
            <p tabIndex="-1" class="w-2 text-center" [innerHTML]="sub | subscriptionToIcon"></p>
            <div class="w-4 text-center">
              <button
                pButton
                tabIndex="0"
                label="{{ 'shared.Unsubscribe' | translate }}"
                class="p-button-danger inline-block font-bold test-unsubscribe-address"
                [attr.aria-label]="$any(sub) | ariaUnsubscribeText"
                (click)="onUnsubscribeClicked(sub, $event.target)"
              ></button>
            </div>
          </div>
        }
      </section>
    } @else {
      <p class="no-subscriptions-text" translate>shared.NoSubscriptionsFound</p>
    }

    <div class="cdk-visually-hidden" aria-live="polite" aria-atomic="true">
      @if (showSubscribeConfirmedText() && subscribeConfirmedText()) {
        <div class="subscription-confirmed-container" [@slideUp]>
          <button
            pButton
            biAutofocus
            icon="pi pi-times"
            [text]="true"
            [rounded]="true"
            [ariaLabel]="'accessibility.CloseNotification' | translate"
            class="subscription-confirmed-close-button"
            (click)="showSubscribeConfirmedText.set(false)"
            (key.enter)="showSubscribeConfirmedText.set(false)"
          ></button>
          <p [innerHTML]="subscribeConfirmedText()" role="status"></p>
        </div>
      }
    </div>
  }
</div>
<div class="flex flex-column md:flex-row flex-wrap gap-2">
  <button
    id="add-address"
    data-uitest="test-add-address"
    pButton
    class="primary-wcag flex-1 subscribe-button font-bold"
    [attr.aria-label]="'shared.Subscribe' | translate"
    [label]="'shared.Subscribe' | translate"
    (click)="onSubscribe.emit(false)"
  ></button>
  @if (canSubscribeViaSupplyNumber()) {
    <button
      pButton
      class="flex-1 primary-wcag subscribe-button font-bold"
      [attr.aria-label]="'iFrame.Subscription.SubscribeBySupplyNr' | translate"
      [label]="supplyNumberSubscribeBtnText()"
      (click)="onSubscribe.emit(true)"
    ></button>
  }
  <button
    data-uitest="exit-button"
    pButton
    class="w-full subscribe-button font-bold primary-wcag"
    [class.flex-1]="!canSubscribeViaSupplyNumber()"
    [label]="'benchmark.Finish' | translate"
    (click)="onReset.emit()"
  ></button>
</div>
